import classnames from 'classnames';
import omit from 'omit.js';
// import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';
import {WebUI, getNid} from "../../wui-core/src/index"
import Icon from '../../wui-icon/src/index';
import {setComponentSize} from "../../wui-core/src/componentStyle"
import { TagProps } from './iTag';

const defaultProps = {
    disabled: false,
    deleted: false,
    colors: 'light',
    bordered: false,
    select: false,
    style: {},
    className: '',
    closeIcon: <Icon type='uf-close'/>,
    icon: null,
    size: 'md',
    activeColor: null,
    type: 'default',
};

const colorsMap: Record<string, string> = {
    dark: 'dark',
    light: 'light',
    success: 'success',
    warning: 'warning',
    danger: 'danger',
    info: 'info',
    invalid: 'invalid',
    start: 'start',
    'half-blue': 'half-blue',
    'half-green': 'half-green',
    'half-dark': 'half-dark',
    'half-yellow': 'half-yellow',
    'half-red': 'half-red',
    '#6366F1': 'purple',
    '#84CC16': 'green',
    '#F97316': 'orange',
    '#EC4899': 'pink',
};

const Tag: React.FC<TagProps> = (props) => {
    const [selected, setSelected] = useState(() => props.selected || false);
    const [visible, setVisible] = useState(() => props.visible ?? true);

    // 替换 getDerivedStateFromProps
    useEffect(() => {
        if ('selected' in props && props.selected !== undefined) {
            setSelected(props.selected);
        }
    }, [props.selected]);

    useEffect(() => {
        if ('visible' in props && props.visible !== undefined) {
            setVisible(props.visible);
        }
    }, [props.visible]);

    const click = useCallback((e: React.MouseEvent<HTMLSpanElement>) => {
        setSelected(prev => !prev);
        props.tagClick && props.tagClick(e);
    }, [props.tagClick]);

    const onDelete = useCallback((e: React.MouseEvent<HTMLSpanElement>) => {
        if (!props.disabled) {
            setVisible(prev => !prev);
            props.onClose && props.onClose(e);
        }
    }, [props.disabled, props.onClose]);

    let {
        colors,
        disabled,
        deleted,
        select,
        className,
        bordered,
        children,
        clsPrefix,
        closeIcon,
        icon,
        size,
        fieldid,
        activeColor,
        type,
        // visible,
        // onClose,//不需要渲染到dom上
        // tagClick,//不需要渲染到dom上
        ...others
    } = props;

    const isSelected = select && selected; // 是否选中态
    let classes = classnames(
        clsPrefix,
        {
            [`${clsPrefix}-${colorsMap[colors!]}`]: !!colorsMap[colors!],
            [`${clsPrefix}-filled`]: type === 'filled',
            [`${clsPrefix}-border`]: (typeof bordered === 'boolean' ? bordered : false) || type === 'bordered',
            [`${clsPrefix}-select`]: select,
            [`${clsPrefix}-selected`]: isSelected, // "选择标签"选中时，改变标签的样式，单独写了一个selected类
            [`${clsPrefix}-delete`]: deleted,
            [`${clsPrefix}-icon`]: !!icon,
            [`${clsPrefix}-${setComponentSize(size)}`]: true,
            [`${clsPrefix}-active-${colorsMap[activeColor!]}`]: isSelected && !!colorsMap[activeColor!],
            // [`${clsPrefix}-colors`]: colors && !colorsMap[colors],
        },
        className,
    );
    let style = colors && !colorsMap[colors] ? {
        ...others.style,
        backgroundColor: colors,
        color: '#fff'
    } : {...others.style};
    style = isSelected && activeColor && !colorsMap[activeColor] ? {
        ...others.style,
        backgroundColor: activeColor,
    } : style;
    let adapterNid = getNid(props);

    return (
        visible ? (
            <span {...omit(others, ['visible', 'onClose', 'tagClick'])} fieldid={fieldid} style={style} className={classes}
                disabled={disabled} onClick={click} {...adapterNid}>
                {icon && <span className="icon">{icon}</span>}
                {children}
                {deleted && <span onClick={onDelete} fieldid={fieldid && `${fieldid}_close`}>{closeIcon}</span>}
            </span>
        ) : null
    );
};

(Tag as any).defaultProps = {...defaultProps};

export default WebUI({name: "tag", defaultProps})(Tag)